var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"autoplay":true,"lottiespeed":0.1,"loop":false,"height":400,"width":600},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }